import { ComponentRef, Injectable } from '@angular/core';
import {
  MmAlertComponent,
  MmAlertContentAlign,
  MmAlertMode,
  MmAlertService,
  MmAlertSize,
  MmAlertType
} from '@metromarkets/components';
import {
  CartAddFailedAlertComponent,
} from '~app/modules/product/components/alerts/cart-add-failed-alert/cart-add-failed-alert.component';
import {
  CartAddServerErrorAlertComponent,
} from '~app/modules/product/components/alerts/cart-add-server-error-alert/cart-add-server-error-alert.component';
import { NUMBER_4000 } from '~shared/constants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartNotificationsService {
  public duration = NUMBER_4000;
  cartSuccessNotifier: Subject<void> = new Subject();
  cartErrorNotifier: Subject<void> = new Subject();

  private alertRefs: Array<ComponentRef<MmAlertComponent>> = [];

  constructor(private readonly alertService: MmAlertService) {
  }

  public removeAllNotifications() {
    this.alertRefs.forEach(alert => this.alertService.removeAlert(alert));
  }

  public showNotEnoughItemsNotification() {

    this.alertRefs.push(this.alertService.addAlert({
      type: MmAlertType.warning,
      component: CartAddFailedAlertComponent,
      size: MmAlertSize.large,
      mode: MmAlertMode.banner,
      duration: this.duration,
      contentAlign: MmAlertContentAlign.center
    }));
  }

  public showErrorNotification() {
    this.alertRefs.push(this.alertService.addAlert({
      type: MmAlertType.warning,
      component: CartAddServerErrorAlertComponent,
      size: MmAlertSize.large,
      mode: MmAlertMode.banner,
      duration: this.duration,
      contentAlign: MmAlertContentAlign.center
    }));
  }

  public notifyCartSuccess(): void {
    this.cartSuccessNotifier.next();
  }

  public notifyCartError(): void {
    this.cartErrorNotifier.next();
  }
}
